export const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const todayIso = () => iso(new Date());
export const addDays = (s, n) => { const d = new Date(`${s}T12:00:00`); d.setDate(d.getDate() + n); return iso(d); };
export const mondayOf = (s) => { const d = new Date(`${s}T12:00:00`); return addDays(s, -((d.getDay() + 6) % 7)); };
export const weekday = (s) => (new Date(`${s}T12:00:00`).getDay() + 6) % 7;
export const dayLabel = (s) => new Date(`${s}T12:00:00`).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
export const runsOn = (t, s) => (t.days || [0, 1, 2, 3, 4, 5, 6]).includes(weekday(s));
